/* ChocoDunes — craving + conversion behaviours (v5). Deferred; zero dependencies.
   Features: scroll reveals, card tilt, slide-out cart, sticky ATC, AJAX add-to-cart, real recommendations. */
(function () {
  'use strict';
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = window.CDMoneyFormat || '\u20B9{{amount}}';
    var n = (cents / 100);
    var s = n.toFixed(2);
    if (s.slice(-3) === '.00') s = s.slice(0, -3);
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    s = parts.join('.');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, s).replace(/<[^>]*>/g, '');
  }

  /* ---------- 1. scroll reveals ---------- */
  function initReveals() {
    if (REDUCE || !('IntersectionObserver' in window)) return;
    var sel = '.cdc-card,.cdpc,.cdg-tile,.cdcat-tile,.cdb-ing,.cdc__head,.cdg__head,.cdcat__head,.cdi__head,.cds__grid,.cdb__panel,.cdp__feats .cdp__feat';
    var els = document.querySelectorAll(sel);
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el, i) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92) return; /* already visible: never hide */
      el.style.setProperty('--rvd', ((i % 6) * 70) + 'ms');
      el.classList.add('cd-reveal');
      io.observe(el);
    });
  }

  /* ---------- 2. pointer tilt on cards ---------- */
  function initTilt() {
    if (REDUCE || !FINE) return;
    var MAX = 3.4, raf = null;
    document.addEventListener('pointermove', function (e) {
      var card = e.target.closest && e.target.closest('.cdc-card, .cdpc');
      if (!card) return;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(760px) rotateX(' + (-py * MAX).toFixed(2) + 'deg) rotateY(' + (px * MAX).toFixed(2) + 'deg) translateY(-6px)';
      });
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      var card = e.target.closest && e.target.closest('.cdc-card, .cdpc');
      if (card && (!e.relatedTarget || !card.contains(e.relatedTarget))) card.style.transform = '';
    }, { passive: true });
  }

  /* ---------- 3. cart drawer ---------- */
  var CDCart = {
    root: null, ov: null, lastFocus: null,
    open: function () {
      if (!this.root) return;
      this.lastFocus = document.activeElement;
      this.root.classList.add('open'); this.ov.classList.add('open');
      document.body.classList.add('cdd-lock');
      this.root.setAttribute('aria-hidden', 'false');
      var c = this.root.querySelector('.cdd__close'); if (c) c.focus();
    },
    close: function () {
      if (!this.root) return;
      this.root.classList.remove('open'); this.ov.classList.remove('open');
      document.body.classList.remove('cdd-lock');
      this.root.setAttribute('aria-hidden', 'true');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },
    added: function () { var self = this; this.refresh().then(function () { self.open(); }); },
    refresh: function () {
      var self = this;
      return fetch((window.routes && window.routes.cart_url || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); return cart; })
        .catch(function () {});
    },
    change: function (key, qty) {
      var self = this;
      return fetch((window.routes && window.routes.cart_change_url || '/cart/change') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (cart) { self.render(cart); });
    },
    render: function (cart) {
      if (!this.root || !cart) return;
      document.querySelectorAll('.cd-bag .count').forEach(function (el) { el.textContent = cart.item_count; });
      var n = this.root.querySelector('[data-cdd-count]'); if (n) n.textContent = cart.item_count;
      var sub = this.root.querySelector('[data-cdd-subtotal]'); if (sub) sub.textContent = money(cart.items_subtotal_price);
      var list = this.root.querySelector('[data-cdd-items]');
      var foot = this.root.querySelector('.cdd__foot');
      if (!list) return;
      if (!cart.items.length) {
        list.innerHTML = '<div class="cdd__empty"><div class="big">Your cart is empty</div><div>Something rich is waiting.</div><a class="cd-btn cd-btn--gold" href="/collections/all">Continue shopping</a></div>';
        if (foot) foot.style.display = 'none';
        return;
      }
      if (foot) foot.style.display = '';
      var html = '';
      cart.items.forEach(function (it) {
        var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]{3,4})(\?|$)/i, '_160x$1$2') + '" alt="" loading="lazy" width="66" height="66">' : '';
        var vt = (it.variant_title && it.variant_title !== 'Default Title') ? '<span class="v">' + it.variant_title + '</span>' : '';
        html += '<li class="cdd__item" data-key="' + it.key + '">' +
          '<div class="pic">' + img + '</div>' +
          '<div class="b"><a class="t" href="' + it.url + '">' + it.product_title + '</a>' + vt +
          '<div class="row"><span class="cdd__qty">' +
          '<button type="button" data-cdd-minus aria-label="Decrease quantity">\u2212</button><span>' + it.quantity + '</span><button type="button" data-cdd-plus aria-label="Increase quantity">+</button>' +
          '</span><span class="pr">' + money(it.final_line_price) + '</span></div>' +
          '<button type="button" class="rm" data-cdd-remove>Remove</button></div></li>';
      });
      list.innerHTML = html;
    },
    init: function () {
      this.root = document.getElementById('cd-cart-drawer');
      this.ov = document.getElementById('cd-cart-overlay');
      if (!this.root || !this.ov) return;
      var self = this;
      this.ov.addEventListener('click', function () { self.close(); });
      this.root.querySelector('.cdd__close').addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.root.classList.contains('open')) self.close(); });
      this.root.addEventListener('click', function (e) {
        var item = e.target.closest('.cdd__item'); if (!item) return;
        var key = item.getAttribute('data-key');
        var qtyEl = item.querySelector('.cdd__qty span');
        var q = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;
        if (e.target.closest('[data-cdd-plus]')) self.change(key, q + 1);
        else if (e.target.closest('[data-cdd-minus]')) self.change(key, Math.max(0, q - 1));
        else if (e.target.closest('[data-cdd-remove]')) self.change(key, 0);
      });
      document.querySelectorAll('.cd-bag').forEach(function (bag) {
        bag.addEventListener('click', function (e) {
          if (window.location.pathname.replace(/\/$/, '').slice(-5) === '/cart') return;
          e.preventDefault(); self.refresh().then(function () { self.open(); });
        });
      });
      document.addEventListener('cd:cart:added', function () { self.added(); });
    }
  };
  window.CDCart = CDCart;

  /* ---------- 4. AJAX add-to-cart on the product form ---------- */
  function initProductForm() {
    document.querySelectorAll('.cdp form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.cdp__atc');
        var orig = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = '\u2026'; }
        var fd = new FormData(form);
        fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw 0; return r.json(); })
          .then(function () {
            if (btn) { btn.textContent = 'Added \u2713'; }
            document.dispatchEvent(new CustomEvent('cd:cart:added'));
            setTimeout(function () { if (btn) { btn.textContent = orig; btn.disabled = false; } }, 1500);
          })
          .catch(function () { if (btn) { btn.textContent = orig; btn.disabled = false; } form.submit(); });
      });
    });
  }

  /* ---------- 5. sticky ATC bar ---------- */
  function initStickyATC() {
    var bar = document.querySelector('[data-cd-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var buy = document.querySelector('.cdp__buy');
    var mainBtn = document.querySelector('.cdp__atc');
    if (!buy || !mainBtn) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var below = en.boundingClientRect.top < 0;
        bar.classList.toggle('show', !en.isIntersecting && below && !mainBtn.disabled);
      });
    }, { threshold: 0 });
    io.observe(buy);
    var sBtn = bar.querySelector('button');
    if (sBtn) sBtn.addEventListener('click', function () {
      var form = mainBtn.closest('form');
      if (form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
    });
  }

  /* ---------- 6. pairs well with — Shopify recommendations (real data only) ---------- */
  function initPairs() {
    var box = document.querySelector('[data-cd-pairs]');
    if (!box) return;
    var pid = box.getAttribute('data-product-id');
    if (!pid) return;
    fetch('/recommendations/products.js?product_id=' + pid + '&limit=4&intent=related', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (data && data.products) || [];
        if (!prods.length) return;
        var grid = box.querySelector('.grid');
        var html = '';
        prods.forEach(function (p) {
          var quote = (p.tags || []).some(function (t) { return /^quote[- ]only$/i.test(String(t).trim()); });
          var img = p.featured_image ? '<img src="' + p.featured_image.replace(/(\.[a-z]{3,4})(\?|$)/i, '_400x$1$2') + '" alt="' + (p.title || '') + '" loading="lazy">' : '';
          html += '<a class="card" href="' + p.url + '"><div class="pic">' + img + '</div><div class="b">' +
            '<p class="t">' + p.title + '</p>' +
            (quote ? '<div class="q">Request a quote</div>' : '<div class="pr">' + money(p.price) + '</div>') +
            '</div></a>';
        });
        grid.innerHTML = html;
        box.classList.add('has-items');
      })
      .catch(function () {});
  }

  /* ---------- boot ---------- */
  function boot() {
    CDCart.init();
    initReveals();
    initTilt();
    initProductForm();
    initStickyATC();
    initPairs();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
